<template>
  <div class="te-time-schedule co-container-md flex flex-col items-center justify-between md:flex-row">
    <div>
      <h3 class="co-display-7 mb-4 text-center font-bold leading-base md:mb-5 md:text-left">
        一日のタイムスケジュール例
      </h3>
      <p class="mb-8 text-co-gray-600 md:mb-0">
        卒業生がテックアカデミーワークスにてどのような時間帯で副業に取り組んでいるかをご紹介。<br>
        本業と両立が可能であることをご確認いただけます。
      </p>
    </div>
    <div class="te-time-schedule-content flex justify-between text-co-gray-600 sm:justify-center md:justify-between">
      <div class="te-time-schedule-item flex flex-col justify-between">
        <img
          src="~/assets/images/Te/TeCommon/Sidejob/TimeSchedule/graph_weekday.svg"
          alt="平日コツコツタイプ"
          width="171"
          height="215"
          loading="lazy"
        >
        <span class="te-time-schedule-notes text-center">
          就寝前2〜3時間を活用
        </span>
      </div>
      <div class="te-time-schedule-item flex flex-col justify-between">
        <img
          src="~/assets/images/Te/TeCommon/Sidejob/TimeSchedule/graph_holiday.svg"
          alt="休日集中タイプ"
          width="174"
          height="216"
          loading="lazy"
        >
        <span class="te-time-schedule-notes text-center">
          日中空いた時間を活用
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.te-time-schedule {
  @media (min-width: 768px) {
    column-gap: 5rem;
  }
}

.te-time-schedule-content {
  column-gap: 4rem;
  @media (min-width: 768px) {
    column-gap: 5.25rem;
  }
}

.te-time-schedule-item {
  row-gap: 0.5rem;
}

.te-time-schedule-item:nth-child(1) {
  @media (min-width: 768px) {
    min-width: 10.8125rem;
  }
}

.te-time-schedule-item:nth-child(2) {
  @media (min-width: 768px) {
    min-width: 10.875rem;
  }
}

.te-time-schedule-notes {
  font-size: 0.75rem;
  line-height: 120%;
  @media (min-width: 768px) {
    font-size: 1rem;
  }
}
</style>
